import c from "react";
import t from "prop-types";
import I from "classnames";
import { View as S } from "./index27.mjs";
import a from "./index234.mjs";
import { ICON_SIZES as m, ICONS as E, ICON_BASE_CLASS as n } from "./index158.mjs";
import { ICON_LIST as L } from "./index158.mjs";
import { VIEW_RENDER_AS as O } from "./index169.mjs";
const _ = ({ size: s, color: e, classes: r }) => I(
  a[n],
  a[`${n}--${s}`],
  e && a[`${n}--svg--${e}`],
  r
), i = ({
  as: s,
  name: e,
  size: r,
  classes: l,
  style: f,
  onClick: p,
  color: u,
  "data-testid": d
}) => {
  try {
    const o = E[e], N = _({ size: r, color: u, classes: l });
    return /* @__PURE__ */ c.createElement(
      S,
      {
        as: s,
        title: e,
        className: N,
        style: f,
        onClick: p,
        "data-testid": d
      },
      o ? /* @__PURE__ */ c.createElement(o, null) : null
    );
  } catch {
    return console.warn(`Icon ${e} not found`), null;
  }
};
i.propTypes = {
  as: t.oneOf(Object.values(O)),
  name: t.string,
  classes: t.string,
  size: t.oneOf(Object.values(m)),
  style: t.object,
  onClick: t.func,
  color: t.string,
  "data-testid": t.string
};
i.defaultProps = {
  size: m.DEFAULT,
  style: {}
};
export {
  E as ICONS,
  n as ICON_BASE_CLASS,
  L as ICON_LIST,
  m as ICON_SIZES,
  i as Icon,
  i as default
};
